import {
  downloadQuestionnaireCsvApi,
  getQuestionnaireDetailApi,
  getQuestionnaireDetailByTestKitApi,
  getQuestionnaireListApi,
  updateVisualizationAccessApi,
} from "@/api/questionnaireApi";
import {
  QuestionnaireFilterStateType,
  UpdateVisualizationAccessPayload,
} from "@/common/types";
import { setLoader } from "@/redux/actions/commonActions";
import Types from "@/redux/types";

export const getQuestionnaires =
  (page: number = 1, filterState: QuestionnaireFilterStateType) =>
  async (dispatch: any) => {
    dispatch(setLoader(true));
    try {
      const result = await getQuestionnaireListApi(
        page,
        filterState.doctor,
        filterState.patient
      );
      if (result) {
        dispatch({
          type: Types.SET_QUESTIONNAIRES,
          payload: result.data,
        });
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

export const getQuestionnaireDetail = (id: number) => async (dispatch: any) => {
  dispatch(setLoader(true));
  try {
    const result = await getQuestionnaireDetailApi(id);
    if (result) {
      dispatch({
        type: Types.SET_QUESTIONNAIRE_DETAIL,
        payload: result.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const getQuestionnaireDetailByTestKit =
  (id: number) => async (dispatch: any) => {
    dispatch(setLoader(true));
    try {
      const result = await getQuestionnaireDetailByTestKitApi(id);
      if (result) {
        dispatch({
          type: Types.SET_QUESTIONNAIRE_DETAIL_BY_TEST_KIT,
          payload: result.data,
        });
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoader(false));
  };

export const downloadQuestionnaireCsv = (id: number) => async () => {
  try {
    const response = await downloadQuestionnaireCsvApi(id);

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    let filename = "data.csv"; // Default filename

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }
    }

    // Create a URL for the blob
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Create a link element and trigger a download
    const a = document.createElement("a");
    a.href = url;
    a.download = filename; // Use extracted filename
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Revoke the URL after download
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.log(error);
  }
};

export const updateVisualizationAccess = (
  payload: UpdateVisualizationAccessPayload,
  callback: () => void
) => {
  return async (dispatch: any) => {
    try {
      dispatch(setLoader(true));
      await updateVisualizationAccessApi(payload);
      callback();
      dispatch(setLoader(false));
    } catch {
      dispatch(setLoader(false));
    }
  };
};
